import { fetchWithAuth } from "../utils/authFetch";

// Pipeline status per job assignment (`jobs`); each write touches one field so two tabs don't clobber each other.

/** GET every candidate's state → { [candidateId]: { jobs } }. */
export async function getCandidateState() {
  const res = await fetchWithAuth("/api/me/candidate-state");
  if (!res.ok) throw new Error(`candidate-state GET ${res.status}`);
  const data = await res.json();
  return data?.states || {};
}

/** Set one candidate's status on one job → { ok, state: { jobs } }. */
export async function patchCandidateStatus(candidateId, { jobId, status }) {
  if (!jobId) throw new Error("patchCandidateStatus needs a jobId");
  const res = await fetchWithAuth(
    `/api/me/candidate-state/${encodeURIComponent(candidateId)}`,
    {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status, jobId }),
    },
  );
  if (!res.ok) throw new Error(`candidate-state PATCH ${res.status}`);
  return res.json();
}
